import {
  ComponentFactoryResolver,
  Injectable,
  TemplateRef,
  Type,
  ViewContainerRef,
  EmbeddedViewRef,
  ComponentRef
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  private afterClosed$ = new Subject<any>();
  private rightSidenav: MatSidenav;
  private viewContainerRef: ViewContainerRef;

  rightSidenavComponentRef: EmbeddedViewRef<any> | ComponentRef<any>;

  public rightExpanded: boolean;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }

  setRightSidenav(sidenav: MatSidenav): void {
    this.rightSidenav = sidenav;
  }

  setViewContainerRef(viewContainerRef: ViewContainerRef): void {
    this.viewContainerRef = viewContainerRef;
  }

  openInRightSidenav(templateOrComponent: TemplateRef<any> | Type<any>, data?: { [key: string]: any }): Subject<any> {
    this.createView(templateOrComponent, data);
    this.rightExpanded = true;
    return this.afterClosed$;
  }

  closeRightSidenav(result?: any): void {
    this.afterClosed$.next(result);
    this.rightExpanded = false;
  }

  resetAfterClosed(): void {
    // Notify subscribers that sidenav is closed
    this.rightExpanded = false;
    if (this.rightSidenavComponentRef) {
      this.rightSidenavComponentRef.destroy();
      this.rightSidenavComponentRef = null;
    }
    this.afterClosed$.complete();
    this.afterClosed$ = new Subject<any>();
  }

  private createView(templateOrComponentRef: TemplateRef<any> | Type<any>, data?: { [key: string]: any }): void {
    this.viewContainerRef.clear();

    if (templateOrComponentRef instanceof TemplateRef) {
      this.rightSidenavComponentRef = this.viewContainerRef.createEmbeddedView(templateOrComponentRef, {$implicit: data});
    } else {
      this.rightSidenavComponentRef = this.viewContainerRef.createComponent(
        this.componentFactoryResolver.resolveComponentFactory(templateOrComponentRef));
      if (data) {
        Object.keys(data)
              .forEach(key => {
                (this.rightSidenavComponentRef as any).instance[key] = data[key];
              });
      }
    }
  }
}
